import { AddressFormFieldNames } from "shared/enums/addressFormFieldNames";
import { createFormConfig, ValidationRules } from "helpers/createFormConfig";
import { PlateformeFormFieldNames } from "./PlateformeFormFieldNames";
import { PlateformeFormValues } from "./PlateformeFormValues";
import { plateformeValidationRules } from "./plateformeValidationRules";
import { initThemeDefaultValues } from "./themeFormConfig";

const plateformeFormConfig = createFormConfig<PlateformeFormValues>(
  plateformeValidationRules as ValidationRules<keyof PlateformeFormValues>,
  {
    [PlateformeFormFieldNames.Name]: '',
    // '' = compagnie d'assurance (variant par défaut de la nature CIE).
    [PlateformeFormFieldNames.SousNature]: '',
    [PlateformeFormFieldNames.LogoFile]: null,
    [PlateformeFormFieldNames.MinimalLogoFile]: null,
    [AddressFormFieldNames.Country]: 'FR',
    ...initThemeDefaultValues,
  }
);

export { plateformeFormConfig };
